<template>
  <div class="gp-content">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'LogsSection',
  computed: {
    tabs() {
      return [
        {
          label: 'Logs',
          link: {
            name: 'logs.index',
          },
          icon: 'logs',
        },
      ];
    },
  },
  mounted() {
    this.SET_SECTION('Logs');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>

<style lang="scss" scoped>

</style>
